import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Compliance from './Compliance';
import Templates from './Templates';
import Companies from './Companies';
import Messages from './Messages';
import Payments from './Payments';
import Settings from './Settings';
import './Dashboard.css';

export default function Dashboard() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('companies');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setMenuOpen(false);
  };

  return (
    <div className="dashboard">
      {/* RESPONSIVE HEADER */}
      <header className="dashboard-header">
        <div className="header-left">
          <h1 className="app-title">Nasar CA</h1>
        </div>
        <div className="header-right">
          <span className="user-info">{user?.email || 'User'}</span>
          <button onClick={handleLogout} className="btn btn-danger btn-sm">Logout</button>
          <button 
            className={`hamburger ${menuOpen ? 'active' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      {/* RESPONSIVE NAVIGATION */}
      <nav className={`dashboard-nav ${menuOpen ? 'open' : ''}`}>
        <button 
          className={`nav-tab ${activeTab === 'companies' ? 'active' : ''}`} 
          onClick={() => handleTabClick('companies')}
        >
          🏢 Companies
        </button>
        <button 
          className={`nav-tab ${activeTab === 'compliance' ? 'active' : ''}`} 
          onClick={() => handleTabClick('compliance')}
        >
          ✓ Compliance
        </button>
        <button 
          className={`nav-tab ${activeTab === 'templates' ? 'active' : ''}`} 
          onClick={() => handleTabClick('templates')}
        >
          📋 Templates
        </button>
        <button 
          className={`nav-tab ${activeTab === 'messages' ? 'active' : ''}`} 
          onClick={() => handleTabClick('messages')}
        >
          💬 Messages
        </button>
        <button 
          className={`nav-tab ${activeTab === 'payments' ? 'active' : ''}`} 
          onClick={() => handleTabClick('payments')}
        >
          💳 Payments
        </button>
        <button 
          className={`nav-tab ${activeTab === 'settings' ? 'active' : ''}`} 
          onClick={() => handleTabClick('settings')}
        >
          ⚙️ Settings
        </button>
      </nav>

      {/* CONTENT AREA */}
      <main className="dashboard-content">
        {activeTab === 'companies' && <Companies />}
        {activeTab === 'compliance' && <Compliance />}
        {activeTab === 'templates' && <Templates />}
        {activeTab === 'messages' && <Messages />}
        {activeTab === 'payments' && <Payments />}
        {activeTab === 'settings' && <Settings />}
      </main>
    </div>
  );
}
